import type {DynamicOptions, DynamicOptionsLoadingProps} from 'next/dynamic'

/**
 * Creates a loading error handler that forwards dynamic import errors.
 * Needed to return the correct 500 status code when the component fails to load on the server.
 * @param loading - Optional custom loading component to render while loading
 * @returns A loading function that throws errors and delegates to the custom loading component
 */
export const makeErrorForwardingDynamicLoader =
  (loading?: DynamicOptions['loading']) =>
  (props: DynamicOptionsLoadingProps) => {
    if (props.error) throw props.error
    return loading ? loading(props) : null
  }
